import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {environment} from 'environment';
import {AuthRequest} from 'shared/auth-request/auth-request';

import {WeekData} from '../model/week-data';

@Injectable()
export class WeekRepository {

  constructor(
    private http: HttpClient,
    private authRequest: AuthRequest,
  ) { }

  public getWeekData(): Observable<WeekData> {
    return this.authRequest.handleRequest(
      this.http.get<WeekData>(environment.week.capacityRoute, {withCredentials: true}));
  }
}
